import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { READ_ONLY_ERROR_CODE, setReadOnlyMode, unsetReadOnlyMode } from './core';
let __config = {
  uri: '',
  header: 'bt-session-id',
  disabled: false
};
const config = options => {
  if (!options) {
    if (!__config.disabled && (!__config.uri || !__config.header)) {
      throw new Error('Session not configured!');
    }
  } else {
    if (options.uri) {
      __config.uri = options.uri;
    }
    if (options.header) {
      __config.header = options.header;
    }
    if (options.disabled) {
      __config.disabled = options.disabled;
    }
  }
  return __config;
};
const getId = () => {
  const {
    disabled,
    header
  } = config();
  if (disabled) return;
  const sessionId = localStorage.getItem(header) || undefined;
  return sessionId === 'undefined' ? undefined : sessionId;
};
const clear = function () {
  var _ref = _asyncToGenerator(function* () {
    const {
      disabled,
      header
    } = config();
    if (disabled) return;
    localStorage.removeItem(header);
  });
  return function clear() {
    return _ref.apply(this, arguments);
  };
}();
const getOrCreate = function () {
  var _ref2 = _asyncToGenerator(function* (sessionId) {
    const {
      disabled,
      uri,
      header
    } = config();
    if (disabled) return;
    const headers = sessionId ? {
      headers: {
        [header]: sessionId
      }
    } : undefined;
    const response = yield fetch(`${uri}/session/`, {
      method: 'post',
      ...headers
    });
    const responseData = yield response.json();
    if (response.status === 503 && responseData.code === READ_ONLY_ERROR_CODE) {
      setReadOnlyMode();
    } else {
      unsetReadOnlyMode();
    }
    localStorage.setItem(header, responseData.session_id);
    return responseData.session_id;
  });
  return function getOrCreate(_x) {
    return _ref2.apply(this, arguments);
  };
}();
const verify = function () {
  var _ref3 = _asyncToGenerator(function* () {
    const {
      disabled
    } = config();
    if (disabled) return;
    const cachedSessionId = yield getId();
    const verifiedSessionId = yield getOrCreate(cachedSessionId);
    return verifiedSessionId;
  });
  return function verify() {
    return _ref3.apply(this, arguments);
  };
}();
const session = {
  config,
  getId,
  clear,
  getOrCreate,
  verify
};
export default session;